<div class="box-item-flip">
  <div class="flip-box">
    <div [ngClass]="'flip-box-front ' + imgClass">
      <div class="inner">
        <h2 class="d-flex justify-content-center">
          <b class="new-line flip-box-title">{{ title }} </b>
        </h2>
      </div>
    </div>
    <div class="flip-box-back flip-card-back-1">
      <div class="inner color-white">

        <p class="d-flex justify-content-center px-3">
          <b>
            {{ description }}
          </b>
        </p>

        <p class="px-3 new-line">
          {{ content }}
        </p>

      </div>
    </div>
  </div>
</div>
